import { defineStore } from 'pinia';

const STORAGE_KEY = 'customer_layout_sidebar_collapsed';

export const useLayoutStore = defineStore('layout', {
  state: () => ({
    sidebarCollapsed: (() => {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored !== null ? stored === 'true' : false;
      } catch {
        return false;
      }
    })(),
  }),
  getters: {
    isSidebarCollapsed: (state) => state.sidebarCollapsed,
  },
  actions: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      try {
        localStorage.setItem(STORAGE_KEY, String(this.sidebarCollapsed));
      } catch {
        // ignore
      }
    },
    setSidebarCollapsed(collapsed) {
      this.sidebarCollapsed = Boolean(collapsed);
      try {
        localStorage.setItem(STORAGE_KEY, String(this.sidebarCollapsed));
      } catch {
        // ignore
      }
    },
  },
});
